import { useState } from "react";
import { Button } from "V2.0/common/button";
import { Dialog, DialogTitle, DialogBody } from "V2.0/common/dialog";
import { PlusIcon } from "@heroicons/react/24/outline";
import { TransferAgentForm } from "./TransferAgentForm";
import { message } from "antd";

function TransferAgentCreate(props) {
  const { createAgent, assistantType, availableSlotTags } = props;

  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const defaultTransferAgent = useState({});

  const handleSubmit = (data) => {
    const startLoading = () => setLoading(true);
    const stopLoading = () => setLoading(false);
    const onSuccess = () => {
      stopLoading();
      setOpen(false);
    };

    createAgent(data, stopLoading, startLoading, onSuccess);
  };

  return (
    <>
      <Button onClick={() => setOpen(true)}>
        <PlusIcon /> Add Agent
      </Button>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <DialogTitle>Add Agent</DialogTitle>
        <DialogBody>
          <TransferAgentForm
            defaultTransferAgent={{}}
            assistantType={assistantType}
            onSubmit={handleSubmit}
            onCancel={() => setOpen(false)}
            loading={loading}
            setLoading={setLoading}
            buttonInfo={{
              buttons: "2",
              primaryLabel: "Add",
              secondaryLabel: "Cancel",
            }}
            availableSlotTags={availableSlotTags}
          />
        </DialogBody>
      </Dialog>
    </>
  );
}

export { TransferAgentCreate };
